import React, { useState, useEffect } from "react";
import Carousel from "react-elastic-carousel";
import CourseItem from "./CourseItem";
import "./popularCourse.css";
import { get, post } from "../../util/axiosConfig/AxiosConfig";

const PopularCourse = (props) => {
  const { mainSecTitle, coursesData } = props;
  console.log("ll",coursesData)
  const [loading, setLoading] = useState(false);
  // const [coursesData, setCoursesData] = useState([]);

  useEffect(() => {
    // fetchData();
  }, []);

  // const fetchData = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await get("web/api/v1/lms-web/open/get-course-list");
  //     setCoursesData(response);
  //   } catch (error) {
  //     setLoading(false);
  //     console.error(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };



  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 600, itemsToShow: 2 },
    { width: 750, itemsToShow: 3 },
    { width: 1000, itemsToShow: 3 },
    { width: 1100, itemsToShow: 4 },
    // { width: 2000, itemsToShow: 4.5 },
  ];

  const settings = {
    breakPoints: breakPoints,
    pagination: true,
    isRTL: false,
    showArrows: false,
    enableMouseSwipe: true,
    className: "my-carousel",
    focusOnSelect: false,
    enableAutoPlay: false,
    disableArrowsOnEnd: true,
    autoTabIndexVisibleItems: true,
    enableSwipe: false,
    pagination: true,
    // itemPadding: [10, 10, 10, 10],
    // outerSpacing: [100]
    renderPagination: ({ pages, activePage, onClick }) => (
      <div className="custom-pagination">
        {pages.map((page) => (
          <button
            key={page}
            className={page === activePage ? "active" : ""}
            onClick={() => onClick(page)}
          >
            {/* {page} */}{" "}
          </button>
        ))}
      </div>
    ),
  };

  // Course card data
  const coursesDataold = [
    {
      courseId: "1",
      title: "XXI-A PMS Distributor",
      author: "Avinash Kulkarni",
      duration: "35",
      price: "599",
    },
    {
      courseId: "2",
      title: "Demo Course 1",
      author: "John Doe",
      duration: "20",
      price: "499",
    },
    {
      courseId: "3",
      title: "XXI-A PMS Distributor",
      author: "Avinash Kulkarni",
      duration: "35",
      price: "599",
    },
    {
      courseId: "4",
      title: "XXI-A PMS Distributor",
      author: "Avinash Kulkarni",
      duration: "35",
      price: "599",
    },
    {
      courseId: "5",
      title: "Demo Course 2",
      author: "John Doe",
      duration: "20",
      price: "499",
    },
  ];
  function getTrainerFullName(trainer) {
    let fullName = trainer.firstName;
    if (trainer.middleName) {
        fullName += " " + trainer.middleName;
    }
    if (trainer.lastName) {
        fullName += " " + trainer.lastName;
    }
    return fullName;
}
  return (
    <React.Fragment>
      {coursesData.length == 0 ? null :
      <>
      <div className="container popular-course">
        <h3 className="course_sec_title">Popular Course</h3>
        <Carousel {...settings} breakPoints={breakPoints}>
          {/* {coursesData.map((course, index) => (
                        <CourseItem key={course.courseId} title={course.title} author={course.author} duration={course.duration} price={course.price} courseId={course.courseId}/>
                    ))} */}
                                  {console.log("cou",coursesData)}

          {coursesData &&
            coursesData.map((course, index) => (
              <CourseItem
                key={index}
                title={course.courseName}
                duration={course.minTime}
                price={course.minPrice}
                isActiveOffer = {course.isActiveOffer}
                offerPrice = {course.offerPrice}
                courseId={course.id}
                courseImg={course.coverImage}
                author={getTrainerFullName(course.trainer)}
                description = {course.description}
                offerName = {course.offerName}
                offerEndDate = {course.offerEndDate}
                courseType = {course.courseTypeId}
              />
            ))}
        </Carousel>
      </div>
      </>}
    </React.Fragment>
  );
};

export default PopularCourse;
